import ApplyCouponButton from "@components/test/ApplyCouponButton";
import CreatePurchaseButton from "@components/test/CreatePurchaseButton";
import GetDearProductsButton from "@components/test/GetDearProductsButton";
import GetShipstationQuotesButton from "@components/test/GetShipStationQuotesButton";
import GetStripeSetupIntentClientSecretButton from "@components/test/GetStripeSetupIntentClientSecretButton";
import UpdatePurchaseButton from "@components/test/UpdatePurchaseButton";
import { Stack } from "@mui/material";
import { useState } from "react";

export default function TestAllAPIs() {
  const [uuid, setUuid] = useState<string>("");

  return (
    <Stack spacing={3}>
      <CreatePurchaseButton onCreated={setUuid} />
      <GetDearProductsButton />
      <UpdatePurchaseButton uuid={uuid} />
      <GetShipstationQuotesButton />
      <GetStripeSetupIntentClientSecretButton uuid={uuid} />
      <ApplyCouponButton />
    </Stack>
  );
}
